export const forwardInstitutionCard = [
  '',
  `mutation forwardInstitutionCard ($input: InputInstitutionCard!) {
    forwardInstitutionCard (input: $input)
  }`,
  'forwardInstitutionCard',
];
